export default __webpack_public_path__ + "static/csa-ea76c1df8fd469c4ad154a0cb6218819.svg";